import { getData } from './data/data';

export default class GameStore {
  constructor() {
    this.steps = {};
  }

  getDataByGameId(id = 1) {
    this.steps = getData(id);
    return this.steps;
  }
}
